import React, { Component } from 'react';
import UserStatistics from './UserStatistics';
import InvestigationStatistics from './InvestigationStatistics';
import UserSider from '../UserSider';
import '../css/style.less';

class UserManhour extends Component {
    state = {
        cur: 'user',
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { cur } = this.state;
        return (
            <div className="content usermanhour">
                <UserSider selectKey='userManhour' openKeys={['sub1']}/>
                <div className="main">
                    <div className="main-content">
                        <div className="tab_flex">
                            <a onClick={() => this.handleBtnClick('user')} className={cur == 'user' ? 'curr' : ''} >
                                按人员统计
                            </a>
                            <a onClick={() => this.handleBtnClick('investigation')} className={cur == 'investigation' ? 'curr' : ''} >
                                按项目统计
                            </a>
                        </div>
                        { cur === 'user' && <UserStatistics /> }
                        { cur === 'investigation' && <InvestigationStatistics /> }
                    </div>
                </div>
            </div>
        )
    }
}

export default UserManhour;



// WEBPACK FOOTER //
// ./src/components/user/manHour/index.js